import { FilterSidebar } from '@/components/filters/filter-sidebar';
import { AppLayout } from '@/components/layout/app-layout';
import { SectionErrorBoundary } from '@/components/layout/section-error-boundary';
import { SchedulesView } from '@/components/schedules/schedules-view';

export const MainPage = () => (
  <AppLayout
    sidebar={
      <SectionErrorBoundary>
        <FilterSidebar />
      </SectionErrorBoundary>
    }
  >
    <SectionErrorBoundary>
      <SchedulesView />
    </SectionErrorBoundary>
  </AppLayout>
);
